import { merge } from 'lodash';
import { Palette } from './palette';
import { Shadows } from './shadows';
import { Poppins, PoppinsMedium, PoppinsBold, PoppinsSemiBold, PoppinsExtraBold, Typography } from './typography';
import { Breakpoints } from './breakpoints';
import React, { useMemo } from 'react';
import { ComponentsOverrides } from './overrides';
import { GlobalStyles } from './globalStyles';
import { BorderRadius } from './borderRadius';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { ClientNames } from '../models/enums/client-names.enum';
export var ThemeConfig = function ThemeConfig(_ref) {
  var children = _ref.children,
      clientName = _ref.clientName;
  // const isLight = useSelector((state) => !state.theme.darkMode)
  var isLight = true;
  var palette = Palette[isLight ? 'light' : 'dark'];

  switch (clientName) {
    case ClientNames.videomaker:
      palette.primary = {
        lighter: '#D4FBEC',
        light: '#7EEBD3',
        main: '#2BBFB8',
        dark: '#229893',
        darker: '#454F5B',
        contrastText: '#fff'
      };
      break;

    case ClientNames.designmaker:
      palette.primary = {
        lighter: '#FFF0D2',
        light: '#FFC378',
        main: '#FF841F',
        dark: '#B7490F',
        darker: '#7A2105',
        contrastText: '#fff'
      };
      break;

    case ClientNames.logomaker:
      // palette.primary = {
      //   lighter: '#FDD5D5',
      //   light: '#F48196',
      //   main: '#DD2F72',
      //   dark: '#9F1766',
      //   darker: '#6A0954',
      //   contrastText: '#fff'
      // }
      break;

    default:
      break;
  }

  var themeOptions = {
    palette: palette,
    shadows: Shadows[isLight ? 'light' : 'dark'],
    typography: Typography,
    shape: BorderRadius,
    breakpoints: Breakpoints,
    components: ComponentsOverrides({
      theme: {
        palette: palette,
        shadows: Shadows[isLight ? 'light' : 'dark'],
        typography: Typography,
        shape: BorderRadius
      }
    }),
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [Poppins, PoppinsMedium, PoppinsBold, PoppinsSemiBold, PoppinsExtraBold]
        }
      }
    }
  };
  if (!isLight) themeOptions.palette.mode = 'dark';
  var theme = useMemo(function () {
    return createMuiTheme(merge({}, themeOptions));
  }, [themeOptions]);
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(GlobalStyles, null), children);
};